import { ChangeEvent } from "react";

import ProductName from "../../../ProductName";
import ProductInfo from "../../../ProductInfo";

import {
  ItemLine,
  QtdColumn,
  VlrColumn,
  CodColumn,
  NoQtdColumn,
  PriceItem,
  PriceLabel,
  PriceValue,
  PriceColumn,
  TotalPriceItem,
  SubPriceItem,
  AddPriceItem,
  PriceItemSeparator,
  PriceSuggestionItem,
  WideVlrColumn,
} from "../../../../styles/common";
import Product from "types/Product";

interface ResultItemProps {
  onQtChange: (product: Product, qtd: number) => void;
  qtdOnOrder: number;
  value: number | string;
  product: Product;
  rowHighlight?: boolean;
}

function ResultItem({
  product,
  onQtChange,
  qtdOnOrder,
  value,
  rowHighlight = false,
}: ResultItemProps) {
  const showQtdBox =
    product.infos.id_falta === "N" &&
    !(product.bloqueio && product.bloqueio.qt_disponivel <= 0);
  let qtDisponivel: number | null = null;
  let maxQtd: number | null = null;
  let readOnly: boolean | null = null;
  if (product.bloqueio) {
    qtDisponivel = product.bloqueio.qt_disponivel;
    maxQtd = (qtDisponivel ? qtDisponivel : 0) - qtdOnOrder;
    readOnly = maxQtd < 0;
  }

  return (
    <ItemLine
      $bloqueio={!!product.bloqueio}
      $lancamento={rowHighlight && product.infos.id_lancamento === "S"}
      $promocao={rowHighlight && product.infos.id_promocao_semanal === "S"}
    >
      <CodColumn>{`${product.full_cd_mercadoria}`}</CodColumn>
      <td>
        <ProductInfo product={product} />
      </td>
      <td>
        <ProductName product={product} />
      </td>
      {showQtdBox ? (
        <QtdColumn
          $estoqueBaixo={
            Number(product.infos.qt_fisica) -
              Number(product.infos.qt_reservada) <=
            15
          }
        >
          <input
            onChange={(event: ChangeEvent<HTMLInputElement>) =>
              onQtChange(
                {
                  ...product,
                  placeholder: qtdOnOrder,
                },
                parseInt(event.target.value, 10) || 0
              )
            }
            placeholder={qtdOnOrder.toString()}
            type="number"
            readOnly={readOnly || undefined}
            value={value}
            max={maxQtd || undefined}
            min={0}
          />
        </QtdColumn>
      ) : (
        <NoQtdColumn>---</NoQtdColumn>
      )}
      <VlrColumn>{`${product.infos.vl_total_sem_st_formated}`}</VlrColumn>
      <VlrColumn>{`${product.infos.vl_imposto_formated}`}</VlrColumn>
      {product.cd_fornecedor.toString() === "343" ? (
        <PriceColumn>
          <PriceItem>
            <PriceLabel>Preço de fabrica:</PriceLabel>
            <PriceValue>{product.infos.vl_preco_fabrica_formated}</PriceValue>
          </PriceItem>
          <SubPriceItem>
            <PriceLabel>Desconto(NF):</PriceLabel>
            <PriceValue>
              {product.infos.vl_desconto_nota_formated}
              <br />({product.infos.pc_desconto_nota}%)
            </PriceValue>
          </SubPriceItem>
          <hr />
          <PriceItem>
            <PriceLabel>Preço(NF):</PriceLabel>
            <PriceValue>{product.infos.vl_preco_liq_formated}</PriceValue>
          </PriceItem>
          <PriceSuggestionItem>
            <PriceLabel>PMC:</PriceLabel>
            <PriceValue>
              {product.infos.vl_preco_maximo_consumidor_formated}
            </PriceValue>
          </PriceSuggestionItem>
          <hr />
          <TotalPriceItem>
            <PriceLabel>Preço sem ST:</PriceLabel>
            <PriceValue>{product.infos.vl_total_sem_st_formated}</PriceValue>
          </TotalPriceItem>
          <AddPriceItem>
            <PriceLabel>ST:</PriceLabel>
            <PriceValue>{product.infos.vl_imposto_formated}</PriceValue>
          </AddPriceItem>
          <PriceItemSeparator />
          <PriceItem>
            <PriceLabel>Preço final com ST:</PriceLabel>
            <PriceValue>{product.infos.vl_total_formated}</PriceValue>
          </PriceItem>
        </PriceColumn>
      ) : (
        <WideVlrColumn>{`${product.infos.vl_total_formated}`}</WideVlrColumn>
      )}
    </ItemLine>
  );
}

export default ResultItem;
